import {apiClient} from './client'
export interface AssignmentNotification {
  id:string;assignmentId:string;title:string;instruction:string
  clubId:string;seasonId:string;tryoutId:string;eventTitle:string
  sessionId:string;sessionTitle:string;activityId:string|null;activityTitle:string|null;createdAt:string
}
export const assignmentNotificationsAPI={
  load:(signal?:AbortSignal)=>apiClient.get<{notifications:AssignmentNotification[]}>('/v2/notifications/loadAssignmentNotifications',{},signal),
  dismiss:(id:string)=>apiClient.post<{id:string;dismissed:true}>(`/v2/notifications/assignmentNotifications/${encodeURIComponent(id)}/dismiss`,{}),
}
export function assignmentNotificationTarget(n:AssignmentNotification) {
 return {path:`/clubhouse/${encodeURIComponent(n.clubId)}/season/${encodeURIComponent(n.seasonId)}/tryout/${encodeURIComponent(n.tryoutId)}/capture`,query:{sessionId:n.sessionId,activityId:n.activityId || 'all',selectorMode:'tasks',groupId:`assignment:${n.assignmentId}`,panel:'scoring',criteria:'assigned'}}
}
